import React from 'react'

import { ActivityStatus } from '../../../../components'
import CommonTypesBaseView from './CommonTypesBaseView'

const columns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true
  },
  {
    id: 'is_active',
    label: 'Active',
    sortable: true,
    cellRenderer: (datum) => <ActivityStatus active={Boolean(datum)} />
  }
]

function CommonTypesView() {
  return (
    <CommonTypesBaseView
      editable
      title="Contact Prefixes"
      category="Contact Prefixes"
      columns={columns}
    />
  )
}

export default CommonTypesView
